import { 
  Directive, 
  ElementRef, 
  HostListener, 
  AfterViewInit, 
  Input, 
  Output, 
  EventEmitter 
} from '@angular/core';
import { debounce } from 'lodash';

@Directive({
  selector: '[appDynamicSize]',
})
export class DynamicSizeDirective implements AfterViewInit {
  @Input() appDynamicSize = true;
  @Output() widthChanged = new EventEmitter<number>();

  private cardWidth: number = 0;

  constructor(private el: ElementRef) {
    this.debouncedAdjustSize = debounce(this.adjustSize.bind(this), 300);
  }

  ngAfterViewInit(): void {
    this.debouncedAdjustSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.debouncedAdjustSize();
  }

  adjustSize(): void {
    const cardElement: HTMLElement | null = this.el.nativeElement.querySelector('.owl-item');

    if (this.appDynamicSize && cardElement) {
      const newCardWidth: number = cardElement.offsetWidth;

      if (newCardWidth !== this.cardWidth) {
        this.cardWidth = newCardWidth;
        this.widthChanged.emit(this.cardWidth);
      }
    }
  }

  debouncedAdjustSize: () => void;
}
